module.exports = __webpack_public_path__ + "img/category_3.02a39580.svg";